import React from "react";
import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";

import { getUserPermissions } from "../../../redux";
import { getUserMenuItems } from "../../../constants/menu";
import { FoundrySoloLogo } from "../../../svgs";

import UserProfileContextMenu from "../../ContextMenus/UserProfileContextMenu/UserProfileContextMenu";
import { StyledTopNavBar, ParentStack, StyledHubButton } from "./styles";
import {
  PERMISSION_LEVEL_KEYS,
  PERMISSIONS_KEY,
} from "../../../constants/permissions";
import SearchNavBar from "./SearchNavBar";
import { CreateButton } from "../../CreateButton";
import NotificationBell from "../../Notifications/NotificationBell";
import { Stack } from "@mui/material";

const NavBar = ({ permissions }) => {
  const navigate = useNavigate();
  const NAV_ITEMS = getUserMenuItems(permissions, false);
  const canSearch =
    permissions?.find((p) => p.id === PERMISSIONS_KEY.SEARCH)?.value >=
    PERMISSION_LEVEL_KEYS.VIEW_ONLY;

  return (
    <StyledTopNavBar className="hub-nav-bar">
      <ParentStack gap="30px">
        <FoundrySoloLogo size={30} fill="#252525" />
        <ParentStack gap="10px">
          {NAV_ITEMS?.map(({ label, path }) => (
            <StyledHubButton
              key={path}
              onClick={() => navigate(path)}
              label={label}
              {...(window.location.pathname?.includes(path) && {
                className: "Nav-selected",
                variant: "contained",
                color: "info",
              })}
              {...(!window.location.pathname?.includes(path) && {
                className: "Nav-unselected",
                color: "neutral",
              })}
            />
          ))}
        </ParentStack>
      </ParentStack>
      <CreateButton />
      <Stack direction="row" gap="15px" alignItems="center" width="100%">
        {canSearch && <SearchNavBar />}
        <NotificationBell />
        <UserProfileContextMenu />
      </Stack>
    </StyledTopNavBar>
  );
};

const mapStateToProps = (state) => ({
  permissions: getUserPermissions(state),
});
export default connect(mapStateToProps)(NavBar);
